import React, { Component } from "react";
import PropTypes from "prop-types";

import { Toast, StorageHandler } from "C4";

import renderHTML from "react-render-html";
import { storageKeys } from "settings";

let errorCheck = null;

export default class FillBlanks extends Component {
  constructor(props) {
    super(props);

    this.state = {
      blanksContent: ["", "", ""],
      correctAnswers: 0,
      question: "",
      toastContent: null,
      headerImage: "",
    };

    errorCheck = setInterval(() => {
      this.props.error(true);
    }, 60 * 1000);
  }

  componentDidMount() {
    this.parseText();
    this.setHeader();
  }

  componentWillUnmount() {
    clearInterval(errorCheck);
  }

  async setHeader() {
    // Load profile image image
    const appInfo = await StorageHandler.load(storageKeys.appInfo);
    const { questionHeader } = appInfo;
    this.setState({ headerImage: questionHeader });
  }

  checkAnswer(i) {
    const { answer } = this.props;
    const { blanksContent } = this.state;
    return answer[i].toLowerCase() === blanksContent[i];
  }

  parseText() {
    const { answer, contentComplete, correctAnswerText, question } = this.props;

    let newQuestion = question;
    answer.forEach((a, i) => {
      const blankMatch = new RegExp(/\[blank[^[\]]*]/);

      const input = `<input
        id="fitb_input_${i}"
        class="input__fitb"
        ${i === 0 ? "autofocus=1" : ""}
        maxlength="${a.length}"
        size="${a.length}"
        tabindex="${i}"
      />`;

      newQuestion = newQuestion.replace(blankMatch, input);
    });
    this.setState({ question: renderHTML(newQuestion) }, () => {
      answer.forEach((a, i) => {
        const input = document.getElementById(`fitb_input_${i}`);
        input.addEventListener("input", (e) => {
          const { blanksContent, correctAnswers } = this.state;
          const newContent = blanksContent;
          newContent[i] = e.target.value.toLowerCase();

          this.setState({ blanksContent: newContent }, () => {
            if (this.checkAnswer(i)) {
              input.disabled = true;
              if (correctAnswers < answer.length - 1) {
                this.setState({ correctAnswers: correctAnswers + 1 });
                document
                  .getElementById(
                    `fitb_input_${i < answer.length - 1 ? i + 1 : i}`
                  )
                  .focus();
              } else {
                this.setState({
                  toastContent: {
                    type: "success",
                    position: "top-center",
                    content: correctAnswerText,
                  },
                });
                contentComplete();
              }
            }
          });
        });
      });
    });
  }

  render() {
    const { question, toastContent, headerImage } = this.state;
    const { disableHeader, disableToast, title } = this.props;
    return (
      <div className="container__question">
        {!disableHeader && (
          <div
            className="container__question--image"
            style={{ backgroundImage: `url(${headerImage})` }}
          />
        )}
        <div className="container__question--content fillBlanks">
          <h4>{question}</h4>
          {!disableToast && (
            <Toast
              trigger={toastContent !== null}
              onOpen={() => {
                this.setState({ toastContent: null });
              }}
              {...toastContent}
            />
          )}
          {this.props.error()}
        </div>
      </div>
    );
  }
}

FillBlanks.propTypes = {
  answer: PropTypes.arrayOf(PropTypes.string).isRequired,
  contentComplete: PropTypes.func.isRequired,
  correctAnswerText: PropTypes.string.isRequired,
  disableHeader: PropTypes.bool,
  error: PropTypes.func,
  question: PropTypes.string.isRequired,
  title: PropTypes.string,
  disableToast: PropTypes.bool,
};

FillBlanks.defaultProps = {
  disableHeader: false,
  error: () => {},
  title: null,
  disableToast: false,
};
